import { compose as i } from "../../tailwind-buddy-interface.js";
const t = i({
  slots: {
    root: ""
  },
  variants: {},
  defaultVariants: {},
  compoundVariants: [
    {
      conditions: {
        withTransition: !0
      },
      class: (
        // A solution of how to apply transition for `height` from `0` to `auto`:
        // https://css-tricks.com/css-grid-can-do-auto-height-transitions/
        // In the future, this might be achievable with `height: calc-size(auto)`:
        // https://github.com/w3c/csswg-drafts/blob/main/css-values-5/calc-size-explainer.md
        /** @tw */
        "grid transition-[grid-template-rows] duration-quick ease-out"
      )
    },
    {
      conditions: {
        isExpanded: !1,
        withTransition: !1
      },
      class: (
        /** @tw */
        "hidden"
      )
    },
    {
      conditions: {
        isExpanded: !1,
        withTransition: !0
      },
      class: (
        /** @tw */
        "grid-rows-[0fr]"
      )
    },
    {
      conditions: {
        isExpanded: !0,
        withTransition: !0
      },
      class: (
        /** @tw */
        "grid-rows-[1fr]"
      )
    }
  ]
})();
export {
  t as collapseVariants
};
